import React from 'react'
import StyledIconButton from '../../Form/StyledIconButton'
import EditIcon from '@material-ui/icons/Edit'

export const ButtonEditUnstyled = props => (
  <StyledIconButton
    className={props.className}
    label="Add Metric"
    onClick={props.onClickHandler}
    cypress_id="edit-unstyled-button"
  >
    <EditIcon />
  </StyledIconButton>
)
